import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardHeader, Modal, ModalBody, ModalHeader, Button, Input, ListGroup, ListGroupItem, Label, CardBody } from "@/Components/ui";
;
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import ServerPaginatedTable from "../../Components/Common/ServerPaginatedTable";
import { BACKEND_HOST, getDataFromUrl, postData } from "../../api";
// cancelPreCouponItem, changePreCouponItem, deletePreCouponItem
import QueryString from "qs";
import axios from "axios";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
const ComplianceArticleList = (props) => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [targetId, setTargetId] = React.useState(0);
    const [auth_key, setAuthKey] = React.useState("");
    const [isAuthPopupOpen, setIsAuthPopupOpen] = React.useState(false);
    const togAuthPopupOpen = () => setIsAuthPopupOpen(!isAuthPopupOpen);
    const fetchData = async () => {
        const data = await getDataFromUrl(`${BACKEND_HOST}/sites/compliance-articles/`);
        setData(data);
    };
    const createConfirm = async (id) => {
        postData(`${BACKEND_HOST}/sites/compliance-user-confirm/`, { article_id: id }, "POST").then((data) => {
            console.log("createConfirm", data);
        }).catch((err) => {
            console.log(err);
            authenticateKeyBySMS(id, true);
        });
    };
    const authenticateKeyBySMS = async (id, retry = null) => {
        const _body = {
            article_id: id,
            auth_key: auth_key,
            user_confirmed: true
        };
        if (retry) {
            _body["retry"] = true;
        }
        const data = await postData(`${BACKEND_HOST}/sites/compliance-user-confirm/`, _body, "PUT");
        if (data) {
            console.log("authenticateKeyBySMS", data);
            if (data.includes("sms_auth") && data.includes("true")) {
                await dialogService.handleAlert("본인인증이 완료되었습니다.");
                fetchData();
            }
            else if (!retry) {
                await dialogService.handleAlert("인증번호가 일치하지 않습니다.");
            }
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (<React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="공문" pageTitle="공문 목록"/>
                    <Col lg={12}>
                        <Card id="customerList">
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm">
                                        <div>
                                            <h5 className="card-title mb-0">공문 목록</h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="hstack gap-2">

                                            {/* <Button
                onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(0) }}
             color="soft-secondary" className="me-1">사용처리</Button> */}
                                            {/* <Button
                onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(1) }}
             color="soft-warning" className="me-1">사용취소</Button>
            <Button
                onClick={() => { changeCheckedRecords(); togDeleteModal(); }}
             color="soft-danger" className="me-1"><i className="ri-delete-bin-2-line"></i></Button> */}
                                        </div>
                                    </div>
                                </Row>
                            </CardHeader>


                            <div className="card-body pt-0">
                                <div>
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {data && data.length > 0 ? data.map(item => (
        // <div key={item.id}>{item.content}</div>
        <Col key={item.id}>
                            <Card>
                                {/* <img className="card-img-top img-fluid" src={img11} alt="Card cap" /> */}
                                <CardHeader>
                                    <h4 className="card-title mb-0">{item.title}</h4>
                                </CardHeader>
                                <CardBody>
                                    {/* <p className="card-text text-muted">{item.content}</p> */}
                                    <div dangerouslySetInnerHTML={{ __html: item.content }}></div>

                                    <div style={{ height: "20px" }}></div>
                                    {!(item.is_confirmed && item.is_auth_key_confirmed)
                ? <>
                                            {/* 확인 체크박스 */}
                                            <div className="form-check mb-3">
                                                <input className="form-check-input" type="checkbox" value="" id={`${item.id}_check_confirm`}/>
                                                <label className="form-check-label" htmlFor={`${item.id}_check_confirm`}>
                                                    위 내용을 확인하였으며, 이에 동의합니다.
                                                </label>
                                            </div>

                                            {/* 본인인증 버튼 */}
                                            <div className="d-grid gap-2">
                                                <Button onClick={async () => {
                        if (!document.getElementById(`${item.id}_check_confirm`).checked) {
                            await dialogService.handleAlert("위 내용을 확인하고 동의해주세요.");
                            return;
                        }
                        setAuthKey("");
                        createConfirm(item.id);
                        setTargetId(item.id);
                        togAuthPopupOpen();
                    }} type="button" color="primary">확인 및 본인인증</Button>
                                            </div>
                                        </>
                : <div style={{ color: "salmon" }}>
                                            공문을 확인 및 본인인증하였습니다.
                                        </div>}
                                    <div style={{ height: "20px" }}></div>

                                </CardBody>
                                <div className="card-footer">
                                    <span className="card-text mb-0">
                                        {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                                    </span><span>&nbsp;&nbsp;&nbsp;</span>
                                    {(item.is_confirmed && item.is_auth_key_confirmed) ? <a href={item.pdf_file} className="btn btn-primary" target="_blank" download>
                                        <i className="ri-download-2-line align-bottom me-1"></i>{" "}
                                        Download PDF
                                    </a> : null}
                                </div>
                            </Card>
                        </Col>)) : null}
                </Container>
            </div>

            <Modal isOpen={isAuthPopupOpen} onClose={togAuthPopupOpen} centered={true} size="md">
                <ModalHeader toggle={togAuthPopupOpen}>
                    문자 인증
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <Label className="form-label">인증번호</Label>
                        <Input type="text" className="form-control" placeholder="인증번호" value={auth_key} onChange={(e) => setAuthKey(e.target.value)}/>
                    </div>
                    <div className="d-flex gap-2 flex-row" style={{ justifyContent: "space-between" }}>
                        <Button color="secondary" type="button" onClick={() => {
            authenticateKeyBySMS(targetId, true);
        }}>
                            번호 재전송
                        </Button>
                        <Button color="primary" type="button" style={{ minWidth: "100px" }} onClick={() => {
            authenticateKeyBySMS(targetId).then(() => { togAuthPopupOpen(); }).catch((err) => {
            });
        }}>
                            확인
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

        </React.Fragment>);
};
export default ComplianceArticleList;
